
import React from 'react';
import '../styles/customtextfield.css';
import { useState, useEffect } from 'react';

const CustomTextField = ({ label, type, readOnly=false, name, onChange, tail, tailContent, value: controlledValue }) => {
    const [internalValue, setInternalValue] = useState('');
    const isControlled = controlledValue !== undefined;
    const value = isControlled ? controlledValue : internalValue;

    useEffect(() => {
        if (isControlled) {
            setInternalValue(controlledValue || '');
        }
    }, [controlledValue, isControlled]);
    
    const handleChange = (e) => {
        const newValue = e.target.value;
        if (!isControlled) {
            setInternalValue(newValue);
        }
        if (onChange) onChange(name, newValue); 
    };

    return (
        <div className="custom-text-field">
            <input type={type} name={name}
                value={value}
                readOnly={readOnly==null?true:readOnly}
                onChange={handleChange}
                required />
            <span className={`placeholder ${value ? 'filled' : ''}`}>
            {!value?label:""}
            </span>
            {tail ? <div className='tail'>{tailContent}</div> : null}
        </div>
    );
};

export default CustomTextField;
